"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogger = exports.init = void 0;
var browser_1 = require("@cian/config/browser");
var AppInfo_1 = require("@cian/system-logger/browser/AppInfo/AppInfo");
var ErrorFilter_1 = require("@cian/system-logger/shared/Filter/ErrorFilter");
var browser_2 = require("@cian/system-logger/browser");
var Logger_1 = require("./internal/Logger");
var filters_1 = require("./internal/filters");
var logger = null;
/**
 * Инициализация браузерного логгера
 *
 * @export
 * @returns {ILogger}
 */
function init() {
    if (logger) {
        return logger;
    }
    var config = (0, browser_1.init)();
    var baseUrl = config.get('logger.browser.baseUrl');
    var pathApi = config.get('logger.browser.pathApi');
    var mcsRunEnv = config.getStrict('mcsRunEnv');
    var application = config.getStrict('projectName');
    var version = config.get('version');
    var errorFilter = new ErrorFilter_1.ErrorFilter((0, filters_1.getFilters)());
    var appInfo = new AppInfo_1.AppInfo(process.env.PROJECT_NAME);
    appInfo.mcsRunEnv = mcsRunEnv;
    appInfo.application = application;
    appInfo.version = version;
    var formatter;
    var transport;
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
        /**
         * TODO: Tree shaking не работает с CommonJS. Необходимо переделать на ES импорты
         */
        var PrettyFormatter = require('@cian/system-logger/shared/Formatter/PrettyFormatter').PrettyFormatter;
        formatter = new PrettyFormatter();
        transport = new browser_2.ConsoleTransport(formatter);
    }
    else {
        formatter = new browser_2.ELKFormatter(appInfo);
        transport =
            baseUrl && pathApi ? new browser_2.HTTPTransport(formatter, urlJoin(baseUrl, pathApi)) : new browser_2.ConsoleTransport(formatter);
    }
    logger = new Logger_1.Logger({ errorFilter: errorFilter, transport: transport });
    return logger;
}
exports.init = init;
/**
 * Возвращает инстанс браузерного логгера. Если логгер был не инициализирован, то выбрасывает исключение
 *
 * @export
 * @returns {ILogger}
 */
function getLogger() {
    if (!logger) {
        throw new Error('Logger must be initialized before accessing it. Forgot to call init() before accessing logger?');
    }
    return logger;
}
exports.getLogger = getLogger;
function urlJoin(baseUrl, path) {
    var needRemoveSlash = baseUrl.endsWith('/') && path.startsWith('/');
    if (!needRemoveSlash) {
        return baseUrl + path;
    }
    return baseUrl + path.slice(1);
}
//# sourceMappingURL=interface.js.map